import { render, staticRenderFns } from "./aboute.vue?vue&type=template&id=56718dd4&scoped=true&"
import script from "./aboute.vue?vue&type=script&lang=js&"
export * from "./aboute.vue?vue&type=script&lang=js&"
import style0 from "./aboute.vue?vue&type=style&index=0&id=56718dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56718dd4",
  null
  
)

export default component.exports